import React from 'react';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';


class MaasOrtalamaRaporDetailTemplate extends React.Component {
  constructor(props) {
    super(props);


    // this.dataSource  =  new CustomStore({
    //     key: 'id',
    //     useDefaultSearch: false,
    //     load: function (loadOptions) {

    //         return props.data.detayInfoList;
    //     }
    // });

 
    this.dataSource =new DataSource({
     
        store: new ArrayStore({
          data:    props.data.data.detayInfoList,
          key: 'id',
        })
      });
       
  }

  render() {
    const { FirstName, LastName } = this.props.data.data;
    return (
      <React.Fragment>
        <DataGrid
          dataSource={this.dataSource}
          showBorders={true}
          columnAutoWidth={true}
        >
          <Column dataField="yil" />
          <Column dataField="kisiSayisi"   />
          <Column dataField="ortalamaTutar"  />
          <Column dataField="artisOran" /> 
        </DataGrid>
      </React.Fragment>
    );
  }
 
}
 

export default MaasOrtalamaRaporDetailTemplate;
